import { Fiches } from '@/generated/classes/AppSchema';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { ObjTypes } from '@/generated/classes/ObjTypes';

export class TreeNode {
  public id: number;
  public name: string;
  public fiche: Fiches;
  public objType: ObjTypes;
  public parentId: number;
  public children: TreeNode[] | null = [];
  public obj: unknown;
  public hasPdf: boolean;
  public canDelete: boolean;
  public picto: string;
  public searchable: string;
  public notifDefType: NotifDefTypes;

  public static  fromJson(node: TreeNode) : TreeNode {
    const treenode = new TreeNode();
    treenode.id = node.id;
    treenode.fiche = node.fiche;
    treenode.objType = node.objType;
    treenode.parentId = node.parentId;
    treenode.children = node.children;
    treenode.obj = node.obj;
    treenode.hasPdf = node.hasPdf;
    treenode.canDelete = node.canDelete;
    treenode.picto = node.picto;
    treenode.searchable = node.searchable;
    treenode.notifDefType = node.notifDefType;
    return treenode;
  }

}

